import React, { useState, useEffect, useLayoutEffect } from "react";
import Layout from "Components/Layout";
import TutorClasses from "./index.module.css";
import { Helmet } from "react-helmet";
import { useForm, Controller } from "react-hook-form";

import { useNavigate } from "react-router-dom";
import { Services } from "Services";
import { useSearchParams } from "react-router-dom";
import ReactLoading from "react-loading";

import MainLoader from "Components/loader/loader";
import { SuccessSwal, warningSwal } from "Util/Toast";
import { compareObjects, CheckIsObjectEmpty } from "Util/Util";
import { useLocation } from "react-router-dom";
window.Buffer = window.Buffer || require("buffer").Buffer;
function Addcategory() {
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [params] = useSearchParams();
    const [edit, setEdit] = useState(false);
    const [mainLoad, setMainLoad] = useState(false);
    const Navigate = useNavigate();

    const {
        register,
        handleSubmit,
        reset,

        formState: { errors },
    } = useForm();
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    useEffect(() => {
        if (params.get("id")) {
            setEdit(true);
            reset({
                Role: location.state?.Role || "",
            });
        }
        // eslint-disable-next-line
    }, []);

    const onSubmit = (data) => {
        // setLoading(true);
        console.log("22423");
        if (edit) {
            let body = compareObjects(data, {
                Role: location.state?.Role || "",
            });

            if (!CheckIsObjectEmpty(body)) {
                Services.updateRoles(
                    "PUT",
                    JSON.stringify(body),
                    token,
                    params.get("id")
                )
                    .then((response) => {
                        if (response.Status === 1) {
                            SuccessSwal("Category Updated", response.Message);
                            Navigate(-1);
                        } else if (response.Status === 0) {
                            setLoading(false);
                            warningSwal("Warning", response.Message);
                        }
                    })
                    .catch((err) => {
                        // alert(err);
                        setLoading(false);
                        alert("something went wrong please try again");
                        console.log(err);
                    });
            } else {
                warningSwal("Warning", "Nothing to update");
            }
        } else {
            Services.addRoles(
                "POST",
                JSON.stringify({ ...data, Status: 1 }),
                token
            )
                .then((response) => {
                    if (response.Status === 1) {
                        Navigate(-1);
                        SuccessSwal("Success", response.Message);
                    } else if (response.Status === 0) {
                        setLoading(false);
                        warningSwal("Warning", response.Message);
                    }
                })
                .catch((err) => {
                    // alert(err);
                    setLoading(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };

    const backButton = () => {
        Navigate(-1);
    };

    return (
        <Layout Active={"Roles"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{edit ? "Update" : "Add"} Role</title>
            </Helmet>
            {mainLoad && <MainLoader />}
            <div className={TutorClasses["Container"]}>
                <button onClick={backButton} className={TutorClasses["back"]}>
                    Back
                </button>
                <div className={TutorClasses["wrapper"]}>
                    <h3>{!edit ? "Add Role" : "Update Role"}</h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {/* <h3>Add Category</h3> */}
                        <div className={TutorClasses["form-control"]}>
                            <label htmlFor="First Name">
                                Role Name <span className="important">*</span>
                            </label>
                            <input
                                {...register("Role", {
                                    required: "this field is required",
                                })}
                            />
                            {errors.Role && <span>{errors.Role.message}</span>}
                        </div>

                        {/*   <div className={TutorClasses["form-control"]}>
                            <label htmlFor="First Name">
                                Status <span className="important">*</span>
                            </label>
                            <select
                                {...register("Status", {
                                    required: true,
                                })}
                                defaultValue={""}>
                                <option value="" disabled>
                                    Select Status
                                </option>
                                <option value="1">Active</option>
                                <option value="2">Inactive</option>
                            </select>
                            {errors.Status && (
                                <span>This field is required</span>
                            )}
                        </div> */}

                        <button disabled={loading}>
                            {" "}
                            {loading ? (
                                <ReactLoading
                                    color="green"
                                    type="spokes"
                                    height={30}
                                    width={30}
                                />
                            ) : (
                                "Submit"
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </Layout>
    );
}

export default Addcategory;
